import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import InputField from "../../../../components/InputField";
import api from "../../../../api/api";
import "../../../../components/table.css";
import BackButton from "../../../../components/BackButton";
import { useAuth } from "../../../../context/AuthContext";

const ViewBookings = () => {
  const [booking, setBooking] = useState([]);
  const { id } = useParams();
  const { user } = useAuth();
  // const [booking, setbooking] = useState(null);

  useEffect(() => {
    const fetchbooking = async () => {
      try {
        const response = await api.get(`/enquiry/viewEnquiry/${id}`);
        console.log("response", response.data);

        setBooking(response.data);
      } catch (error) {
        console.error("Failed to fetch booking:", error);
      }
    };

    fetchbooking();
  }, [id]);

return (
    <>
      <BackButton />
      <form>
        <div className="row g-3">
          {(user?.user_role === "SuperAdmin" || user?.user_role === "Admin") && (
            <>
              <div className="col-sm-6 col-md-4">
                <InputField label="Booking Party Name" value={booking.client_name} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField label="Booking Company Name" value={booking.client_company} disabled />
              </div>
            </>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="Incoterm" value={booking.incoterm} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Shipper Name" value={booking.first_shipper_name || ""} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Consignee Name" value={booking.first_consignee_name || ""} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Shipment Segment" value={booking.shipment_segment} disabled />
          </div>
          {[
            "Door to Door",
            "ICD to Door",
            "Door to Port",
            "ICD to Port",
          ].includes(booking.incoterm) && (
            <>
              <div className="col-sm-6 col-md-4">
                <InputField label="Place Of Receipt" value={booking.place_of_receipt} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField label="POR Pin Code" value={booking.place_of_receipt_pin} disabled />
              </div>
            </>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="Port of Loading" value={booking.pol} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Port of Discharge" value={booking.pod} disabled />
          </div>
          {["Door to Door", "ICD to Door", "Port to Door"].includes(booking.incoterm) && (
            <>
              <div className="col-sm-6 col-md-4">
                <InputField label="Final Port Of Delivery" value={booking.final_port_of_delivery} disabled />
              </div>
              <div className="col-sm-6 col-md-4">
                <InputField label="FPOD Pin Code" value={booking.final_port_of_delivery_pin} disabled />
              </div>
            </>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="Freight Terms" value={booking.freight_terms} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Routing" value={booking.routing || ""} disabled />
          </div>
          {booking.routing === "Indirect" && (
            <div className="col-sm-6 col-md-4">
              <InputField label="Transshipment Hub" value={booking.transshipment_hub || ""} disabled />
            </div>
          )}
          {["FE", "LE"].includes(booking.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <InputField label="Stuffing At" value={booking.stuffing_destuffing_At} disabled />
            </div>
          )}
          {["LI", "FI"].includes(booking.shipment_segment) && (
            <div className="col-sm-6 col-md-4">
              <InputField label="Destuffing At" value={booking.stuffing_destuffing_at} disabled />
            </div>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="Nature of Cargo" value={booking.nature_of_cargo} disabled />
          </div>
          {booking.nature_of_cargo === "Hazardous" && (
            <div className="col-sm-6 col-md-4">
              <InputField label="HAZ Class" value={booking.haz_class} disabled />
            </div>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="HS Code" value={booking.hs_code} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="HSN Description" value={booking.hs_description} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Document Type" value={booking.document_type} disabled />
          </div>
          {booking.document_type === "Original" && (
            <div className="col-sm-6 col-md-4">
              <InputField label="Document Count" value={booking.document_count} disabled />
            </div>
          )}
          {booking.switch_bl === "Yes" && (
            <div className="col-sm-6 col-md-4">
              <InputField label="Switch BL" value={booking.switch_at} disabled />
            </div>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="Packaging Type" value={booking.packaging_type} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Packaging Count" value={booking.packaging_count} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Goods Value" value={booking.goods_value} disabled />
          </div>

          {/* Container Details */}
          {booking.containerDetails?.length > 0 && (
            <div className="container-details mt-3">
              <h5>Container Details</h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    {booking.shipment_segment !== "LE" &&
                      booking.shipment_segment !== "LI" && (
                        <th>Container Type</th>
                      )}
                    {!["LE", "LI"].includes(booking.shipment_segment) && (
                      <th>Gross Cargo Weight</th>
                    )}
                    <th>Length</th>
                    {!["FE", "FI"].includes(booking.shipment_segment) && (
                      <th>Breadth</th>
                    )}
                    {!["FE", "FI"].includes(booking.shipment_segment) && (
                      <th>Height</th>
                    )}
                    {["LE", "LI"].includes(booking.shipment_segment) && (
                      <th>CBM</th>
                    )}
                    {booking.nature_of_cargo === "Temperature Control" && (
                      <th>Temperature</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {booking.containerDetails.map((container, idx) => (
                    <tr key={idx}>
                      {booking.shipment_segment !== "LE" &&
                        booking.shipment_segment !== "LI" && (
                          <td>{container.container_type}</td>
                        )}
                      {!["LE", "LI"].includes(booking.shipment_segment) && (
                        <td>{container.container_weight}</td>
                      )}
                      {!["FE", "FI"].includes(booking.shipment_segment) && (
                        <td>{container.container_length}</td>
                      )}
                      {!["FE", "FI"].includes(booking.shipment_segment) && (
                        <td>{container.container_breadth}</td>
                      )}
                      {!["FE", "FI"].includes(booking.shipment_segment) && (
                        <td>{container.container_height}</td>
                      )}
                      {["LE", "LI"].includes(booking.shipment_segment) && (
                        <td>
                          {container.container_length && container.container_breadth && container.container_height
                            ? (
                                (parseFloat(container.container_length) *
                                  parseFloat(container.container_breadth) *
                                  parseFloat(container.container_height)) /
                                1000000
                              ).toFixed(2)
                            : "0.00"}
                        </td>
                      )}
                      {booking.nature_of_cargo === "Temperature Control" && (
                        <td>{container.container_temperature}</td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="col-sm-6 col-md-4">
            <InputField label="CHA Services Required" value={booking.cha_required} disabled />
          </div>
          <div className="col-sm-6 col-md-4">
            <InputField label="Remarks" value={booking.remarks} disabled />
          </div>
        </div>
      </form>
    </>
  );
};

export default ViewBookings;
